import React, { createRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _, { isArray, get } from 'lodash';
import { Typography, ExpandCollapse } from '@telus-uds/components-web';
import request, { apiHost } from '../utils/request';
import useOrderPdf from '../hooks/useOrderPdf';
import FormField from './formField';
import ValidateLoader from '../UI/validateLoader';
import ProgressBar from '../design/progressBar';
import UserDetailsForm from './userDetailsForm';
import Note from '../note';
import RepeatedForm from './repeatedForm';
import { msgDisplay, getFieldValue } from './utils';
import { getFormData, isRelatedFieldExisted } from './formStepOCDRUtils';
import { findField } from './formStepUtils';
import { useTranslationsContext } from '../context/TranslationsContext';
import { Box } from '../design/css';
import { useLocaleContext } from '../context/LocaleContext';
import { GroupTitle, GroupWrapper } from './css';
import {
  typeCheckbox,
  maxUploadSizeValueWLS,
  maxUploadSizeErrorMessageWLS,
  inputTypeFile,
  keyFileSizeExceeded,
  roleLabels,
  localeFrench,
  stepKeyMain,
  fieldActivationLanguage,
  categoryOCDR,
  ocdrForm,
  fieldDirectRouting,
  fieldOperatorConnect,
  fieldProductSelectionOCDR,
  fieldMicrosoftCloudAndAdvisoryServices
} from '../utils/constant';
import { localeFr, getPathVariables } from '../misc';
import { scrollToErrors } from '../utils/utils';
import OrderSummary from './orderSummary/ocdrOrderSummary';
import OcdrStatusBar from '../design/ocdrStatusBar';
import PrequalificationSection from './ocdrHelper/prequalificationSection';
import ProductDetailsSection from './ocdrHelper/productDetailsSection';
import Services from './ocdrComponents/services';
import {
  applyBundlePricing,
  discountOnServices,
  getCategoryDataForMicrosoftCloudProducts,
  getCategoryWiseStateDataForProducts,
  getIsQuoteApproveRequired,
  getIsQuoteApproveRequiredForMCProduct,
  getOcdrSummaryPayload,
  getServicesTotals
} from './ocdrComponents/ocdrUtils';
import OcrdService from './ocdrComponents/ocdrservice/ocdrAddService';
import OcdrAddProduct from './ocdrComponents/ocdrAddProduct/ocdrProductAdd';
import MicrosoftCloudAdvisoryServicesSection from './ocdrHelper/microsoftCloudAdvisoryServicesSection';
import OcdrHardware from './ocdrComponents/ocdrHarware/ocdrHardware';

const formFieldsGroup = 'formFieldsGroup';
const formSection = 'formSection';
const userDetailsKey = 'userDetails';
const repeatedFormKey = 'repeatedForm';
const typeMultiCheckbox = 'MultiCheckbox';
const formSectionTitle = 'formSectionTitle';
const typeServiceTable = 'ServiceTable';
const profile = request.getProfile();

const FormStepOCDR = ({
  stepData = null,
  steps,
  step,
  setFormRef = null,
  onFormSubmit = null,
  orderData = {},
  hideProgressBar = false,
  isEditing,
  formName,
  onSaveAndExit = () => {},
  updateStep = () => {},
  history,
  isCreateOrderButtonVisible = false,
  setOrderData = () => {}
}) => {
  if (!stepData) return null;
  const translations = useTranslationsContext();
  const locale = useLocaleContext();
  const {
    contentfulValues: { valueEnglish, valueFrench },
    summaryForm: { summaryLabel },
    formStep: {
      minValueErrorMessage,
      maxValueErrorMessage,
      minLengthErrorMessage,
      maxLengthErrorMessage
    },
    modalForm: { fieldRequiredMessage }
  } = translations;
  const {
    fields: {
      name: formStepName,
      backendKey: formStepBackendKey,
      formStepFields,
      modalForms
    }
  } = stepData;
  const formStepRef = createRef();
  const [isDataLoaded, setDataLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [isFormTouched, setIsFormTouched] = useState(false);
  const [isFormSubmit, setIsFormSubmit] = useState(false);
  const [formFields, setFormFields] = useState({});
  const [sections, setSections] = useState([]);
  const [products, setProducts] = useState({});
  const [matchProductsData, setMatchProductsData] = useState({});
  const [productsOrderData,setProductsOrderData] = useState(false);
  const [productPriceofMC, setProductPriceofMC] = useState({});
  const [hardwareData, setHardwareData] = useState({});
  const [ocdrServiceAdd, setOcdrServiceAdd] = useState({});
  const [ocdrProductAdd, setocdrProductAdd] = useState({});
  const [microsoftlicensingSelections,setMicrosoftlicensingSelections] = useState([]);
  const [errorMC, setErrorMC] = useState(false);
  const quotePdf = useOrderPdf();
  const [downloadingLang, setDownloadingLang] = useState(null);
  const { role } = (typeof profile !== 'undefined' && profile) || {};
  let hasProductDirectRouting;
  let hasProductOperatorConnect;
  let hasProductMicrosoftCloud;

  const onChangeOcdrService = data => {
    setOcdrServiceAdd(data);
  };
  const onChangeOcdrProduct = data => {
    setocdrProductAdd(data);
  };
  const onChangeHardwareData = data => {
    setHardwareData(data);
  };
  const getDefaultValue = (key, value) => {
    if (isEditing && orderData) return orderData[key];
    return value || '';
  };
  const open = sections.reduce((acc, section) => {
    const {
      fields: { name, isPanelInitiallyOpen, formFields: sectionFields }
    } = section;
    if (isPanelInitiallyOpen) {
      acc.push(name);
    } else {
      const isErrors =
        sectionFields &&
        sectionFields.find(item => {
          const {
            fields: { name: itemName }
          } = item;
          return formErrors[itemName];
        });
      if (typeof isErrors !== 'undefined') acc.push(name);
    }
    return acc;
  }, []);
  const normalizedFields = (data, initFields) => {
    let result = initFields;
    if (data) {
      data.forEach(item => {
        const { sys, fields } = item;
        const {
          name,
          type,
          required,
          value,
          minValue,
          maxValue,
          minLength,
          maxLength,
          price,
          monthlyPayment,
          options,
          tooltip,
          noteAppearsBelowField,
          customFieldErrorMessage,
          resetFields,
          customResetFields
        } = fields;
        const {
          contentType: {
            sys: { id }
          }
        } = sys;
        const key = name;
        const ref = createRef();
        if (id === formFieldsGroup) {
          result = normalizedFields(fields.fields, result);
        } else if (id === formSection) {
          result = normalizedFields(fields.formFields, result);
        } else if (id === userDetailsKey) {
          result = normalizedFields(fields.formStepFields, result);
        } else if (id === repeatedFormKey) {
          const formObjectKeys = fields.formFields.reduce(
            (acc, { fields: { name: formNameKey, value: defaultValue } }) => {
              acc[formNameKey] = defaultValue;
              return acc;
            },
            {}
          );
          result[fields.key] = [formObjectKeys];
        } else if (!Object.prototype.hasOwnProperty.call(result, key)) {
          let defaultValue = getDefaultValue(key, value);
          let updatedMonthlyPayment = monthlyPayment;
          let updatedPrice = price;
          if (['Select', 'Radio'].includes(type)) {
            if (options && defaultValue) {
              const currentOption = options.find(
                o => o.fields.value === defaultValue
              );
              if (typeof currentOption !== 'undefined') {
                updatedPrice = currentOption.fields.price;
                updatedMonthlyPayment = currentOption.fields.monthlyPayment;
              }
            }
          }
          if (type === typeMultiCheckbox) {
            if (defaultValue && defaultValue.length > 0 && options) {
              const updateDefaultValue =
                typeof defaultValue === 'string'
                  ? defaultValue.split(',')
                  : defaultValue;
              const mappedValues = updateDefaultValue.reduce(
                (ac, a) => ({ ...ac, [a]: true }),
                {}
              );
              updatedPrice = options.reduce(
                (ac, a) =>
                  ac + ((mappedValues[a.fields.value] && a.fields.price) || 0),
                0
              );
              updatedMonthlyPayment = options.reduce(
                (ac, a) =>
                  ac +
                  ((mappedValues[a.fields.value] && a.fields.monthlyPayment) ||
                    0),
                0
              );
            }
          }
          /**
           * Condition to select default activation lagnguage
           * based on the curren locale
           */
          if (key === fieldActivationLanguage) {
            const currentLocale = getPathVariables(window.location.pathname)[0];
            defaultValue =
              currentLocale === localeFr ? valueFrench : valueEnglish;
          }
          result[key] = {
            name,
            ref,
            type,
            value: defaultValue || value,
            initPrice: updatedPrice || 0,
            price: updatedPrice || 0,
            initMonthlyPayment: updatedMonthlyPayment || 0,
            monthlyPayment: updatedMonthlyPayment || 0,
            minValue,
            maxValue,
            minLength,
            maxLength,
            isRequired: required || false,
            isVisible: true,
            options,
            tooltip,
            noteAppearsBelowField,
            customFieldErrorMessage
          };

          if (resetFields) {
            result[key].resetFields = resetFields;
          }

          if (customResetFields) {
            result[key].customResetFields = customResetFields;
          }

          if (type === 'Checkbox') {
            result[key].checked = defaultValue;
          }
          if (
            type === 'PlusMinusInput' &&
            defaultValue === undefined &&
            value
          ) {
            result[key].value = value;
          }
        }
      });
    }
    return result;
  };
  const formSections = formStepFields.filter(({ sys }) => {
    const {
      contentType: {
        sys: { id }
      }
    } = sys;
    return id === formSection;
  });
  const getHiddenSections = fields => {
    const hiddenSections = [];
    formSections.forEach(section => {
      const {
        fields: { name: sectionName }
      } = section;
      if (
        !isRelatedFieldExisted(section.fields, fields, orderData, isFormTouched)
      ) {
        hiddenSections.push(sectionName);
      }
    });
    return hiddenSections;
  };
  const updateSections = updatedSections => {
    let newSections = [...formSections];
    updatedSections.forEach(item => {
      newSections = newSections.filter(section => section.fields.name !== item);
    });
    setSections(newSections);
  };

  const getProducts = async () => {
    request.get(`/products`).then(productItem => {
      const isProductsEmpty = Object.entries(products).length === 0

      if(isProductsEmpty){
        setProducts(getCategoryWiseStateDataForProducts(productItem.data));
      }
      setMatchProductsData(getCategoryWiseStateDataForProducts(productItem.data))
      setProductPriceofMC(getCategoryDataForMicrosoftCloudProducts(productItem.data))
      setDataLoaded(false);
      setProductsOrderData(true);
    });
  };


  const getHarwareAndServiceTotal = type => {
    if (step === 1) {
      if (hasProductOperatorConnect || hasProductDirectRouting) {
        if (type === 'monthly' && hardwareData['adjustedTotalPrice']) {
          return (
            hardwareData['adjustedTotalPrice'].totalMonthly +
            ocdrServiceAdd['adjustedTotalPrice'].totalMonthly
          );
        } else if (type === 'oneTime' && hardwareData['adjustedTotalPrice']) {
          return (
            hardwareData['adjustedTotalPrice'].totalOneTime +
            ocdrServiceAdd['adjustedTotalPrice'].totalOneTime
          );
        }
      }
    } else if (orderData && Object.keys(orderData).length > 0) {
      if (
        orderData.productSelectionOCDR &&
        (orderData.productSelectionOCDR.includes(fieldDirectRouting) ||
          orderData.productSelectionOCDR.includes(fieldOperatorConnect))
      ) {

        const hardwareDataMonthly = orderData.hardwareData.adjustedTotalPrice
          ? orderData.hardwareData.adjustedTotalPrice.totalMonthly
          : 0;
        const hardwareDataOneTime = orderData.hardwareData.adjustedTotalPrice
          ? orderData.hardwareData.adjustedTotalPrice.totalOneTime
          : 0;
          
        if (type === 'monthly') {
          return (
            hardwareDataMonthly +
            orderData.ocdrServiceAdd.adjustedTotalPrice.totalMonthly
          );
        } else if ('oneTime') {
          return (
            hardwareDataOneTime +
            orderData.ocdrServiceAdd.adjustedTotalPrice.totalOneTime
          );
        }
      }
    }
    return 0;
  };

  const getMicrosoftCloudTotal = type => {
    if (step === 1) {
      if (hasProductMicrosoftCloud) {
        if (type === 'monthly' && ocdrProductAdd['adjustedTotalPriceDiscount']) {
          return ocdrProductAdd['adjustedTotalPriceDiscount'].totalMonthlyPriceDiscount;
        } else if (type === 'oneTime' && ocdrProductAdd['adjustedTotalPriceDiscount']) {
          return ocdrProductAdd['adjustedTotalPriceDiscount'].totalOneTimePriceDiscount;
        }
      }
    } else if (orderData && Object.keys(orderData).length > 0) {
      if (
        orderData.productSelectionOCDR &&
        (orderData.productSelectionOCDR.includes(fieldMicrosoftCloudAndAdvisoryServices))
      ) {
        if (type === 'monthly') {
          return (
            orderData.ocdrProductAdd.adjustedTotalPriceDiscount.totalMonthlyPriceDiscount
          );
        } else if ('oneTime') {
          return (
            orderData.ocdrProductAdd.adjustedTotalPriceDiscount.totalOneTimePriceDiscount
          );
        }
      }
    }
    return 0;
  };

  const resetHardwarAndServices = () => {
    setHardwareData({});
    setOcdrServiceAdd({});
    setOrderData({
      ...orderData,
      hardwareData: {},
      ocdrServiceAdd: {}
    });
  };

  useEffect(() => {
    getProducts();
  }, []);

  useEffect(() => {
    if (
      (!isEditing && formStepFields) ||
      (isEditing && orderData && orderData.id)
    ) {
      const updatedFields = normalizedFields(formStepFields, formFields);
      setFormFields(updatedFields);
      updateSections(getHiddenSections(updatedFields));
      setIsLoading(false);
      setIsFormTouched(false);
      if (!isDataLoaded && orderData.products) setProducts(orderData.products);
      setDataLoaded(true);
      if (formStepRef && formStepRef.current)
        formStepRef.current.scrollTo(0, 0);
    }
  }, [formStepFields, orderData, locale, productsOrderData]);
  const sectionIsVisible = name =>
    typeof sections.find(item => item.fields.name === name) !== 'undefined';
  const getRepeatedFormErrors = (contentfulFields, formValues) => {
    const fields = contentfulFields.filter(
      ({ fields: content }) => content.required || content.fieldValidation
    );
    return formValues.filter(formValue => {
      let filteredValues = fields.filter(
        ({ fields: { name: formKeyValue } }, index) => {
          return (
            !formValue[formKeyValue] || fields[index].fields.fieldValidation
          );
        }
      );
      const removeValidationErrors =
        filteredValues &&
        filteredValues.filter(item => {
          if (item.fields.fieldValidation) {
            if (
              item.fields.fieldValidation.fields.logic &&
              item.fields.fieldValidation.fields.logic === 'regex'
            ) {
              // Add regex logic
            }
          }
          return null;
        });
      filteredValues = removeValidationErrors;
      return filteredValues.length > 0;
    });
  };
  const getAccumulatedFilesSize = files => {
    const keys = Object.keys(files);
    let size = 0;
    // eslint-disable-next-line no-unused-expressions
    keys.length > 0 &&
      keys.forEach(key => {
        if (files[key]) {
          const [file] = Object.keys(files[key]);
          if (files[key][file] && files[key][file].size) {
            size += files[key][file].size;
          }
        }
      });
    return size;
  };
  const getErrors = (data, errors) => {
    scrollToErrors(errors);
    let result = errors;
    if (!data) return result;
    data.forEach(({ sys, fields }) => {
      const {
        contentType: {
          sys: { id }
        }
      } = sys;
      const { name: key, type, customFieldErrorMessage } = fields;
      const {
        value,
        minValue,
        maxValue,
        isRequired,
        isVisible,
        ref,
        minLength,
        maxLength
      } =
        formFields &&
        Object.prototype.hasOwnProperty.call(formFields, key) &&
        formFields[key];
      const { files } = formFields;
      if (
        id === formFieldsGroup &&
        isRelatedFieldExisted(fields, formFields, orderData, isFormTouched)
      ) {
        result = getErrors(fields.fields, result);
      } else if (id === formSection && sectionIsVisible(key)) {
        result = getErrors(fields.formFields, result);
      } else if (id === userDetailsKey) {
        result = getErrors(fields.formStepFields, result);
      } else if (id === repeatedFormKey) {
        const repeatedFormErrors = getRepeatedFormErrors(
          fields.formFields,
          formFields[fields.key]
        );
        if (repeatedFormErrors.length) {
          result[fields.key] = repeatedFormErrors;
        } else {
          delete result[fields.key];
        }
      } else if (isVisible) {
        if (isRequired) {
          let fieldValue = value;
          if (type === typeMultiCheckbox) {
            const multiCheckboxValue = getFieldValue(key, formFields);
            fieldValue = multiCheckboxValue && multiCheckboxValue.length > 0;
          }
          if (
            !fieldValue &&
            isRelatedFieldExisted(fields, formFields, orderData, isFormTouched)
          ) {
            if (!(type === typeCheckbox && formFields[key].checked)) {
              result[key] = {
                text: customFieldErrorMessage || fieldRequiredMessage,
                ref
              };
            } else {
              delete result[key];
            }
          } else {
            delete result[key];
          }
        }
        if (typeof minValue !== 'undefined' && parseFloat(value) < minValue) {
          result[key] = {
            text: msgDisplay(minValue, minValueErrorMessage),
            ref
          };
        }
        if (typeof maxValue !== 'undefined' && parseFloat(value) > maxValue) {
          result[key] = {
            text: msgDisplay(maxValue, maxValueErrorMessage),
            ref
          };
        }
        if (minLength && value && value.length < minLength) {
          result[key] = {
            text: msgDisplay(minLength, minLengthErrorMessage),
            ref
          };
        }
        if (maxLength && value && value.length > maxLength) {
          result[key] = {
            text: msgDisplay(maxLength, maxLengthErrorMessage),
            ref
          };
        }
        if (type === inputTypeFile && files) {
          if (getAccumulatedFilesSize(files) > maxUploadSizeValueWLS) {
            result[keyFileSizeExceeded] = {
              text: maxUploadSizeErrorMessageWLS,
              ref
            };
          } else {
            delete result[keyFileSizeExceeded];
          }
        }
        if (fields.fieldValidation && fields.fieldValidation.fields) {
          if (
            typeof fields.appearsAfterField === 'undefined' ||
            (typeof fields.appearsAfterField !== 'undefined' &&
              isRelatedFieldExisted(
                fields,
                formFields,
                orderData,
                isFormTouched
              ))
          ) {
            const {
              errorMessage,
              logic,
              value: expectedValue
            } = fields.fieldValidation.fields;
            let hasError = false;
            switch (logic) {
              case 'equal':
                // eslint-disable-next-line eqeqeq
                hasError = !expectedValue.split('|').includes(value);
                break;
              case 'regex':
                {
                  const regexLogic = new RegExp(expectedValue);
                  hasError = !regexLogic.test(value);
                }
                break;
              case 'gt':
                hasError = parseInt(value, 10) < parseInt(expectedValue, 10);
                break;
              case 'gte':
                hasError = parseInt(value, 10) <= parseInt(expectedValue, 10);
                break;
              case 'lt':
                hasError = parseInt(value, 10) < parseInt(expectedValue, 10);
                break;
              default:
            }
            if (hasError) result[key] = { text: errorMessage, ref };
            if ((!isRequired && !value) || (!isRequired && !hasError))
              delete result[key];
          }
        }
        if (type === 'MCPopup') {
          if (ocdrProductAdd.selections.length <= 0) {
            setErrorMC(true);
            result[key] = {
              text: 'required',
              ref
            };
          } else {
            setErrorMC(false);
            delete result[key];
          }
        }

        if (!hasProductDirectRouting) {
          delete result['directRoutingServices'];
          delete result['access'];
        }

        if (!hasProductMicrosoftCloud) {
          delete result['addProductMC'];
          delete result['dealSupportNumber'];
          delete result['orderInclude'];
          delete result['orderRequestType'];
          delete result['businessIncorporationDate'];
          delete result['businessIncorporationNumberOCDR'];
          delete result['dsDetails'];
          delete result['dsNumber'];
          delete result['pinOCDR'];
          delete result['domainName'];
        }

        if (type === typeServiceTable) {
          const { customConfigurations } = fields;
          const serviceList = get(
            products,
            `${customConfigurations.categoryName}.${customConfigurations.subCategoryName}`,
            []
          );
          const isServiceMandatory = serviceList.some(
            serviceItem => serviceItem.isMandatory
          );
          const doesServiceHaveError =
            isServiceMandatory &&
            serviceList.some(serviceItem => {
              return (
                (!serviceItem.price || !serviceItem.quantity) &&
                serviceItem.isMandatory
              );
            });

          if (doesServiceHaveError) {
            result[key] = 'Please fill all the mandatory rows in this table';
          } else {
            delete result[key];
          }
        }
      }
    });
    return result;
  };
  const saveAndExit = () => {
    if (step === 1) {
      if (!hasProductDirectRouting && !hasProductOperatorConnect) {
        resetHardwarAndServices();
      }
      const fields = getFormData(formFields, products);
      if (Object.entries(fields).length) {
        onSaveAndExit({
          ...fields,
          hardwareData,
          ocdrProductAdd,
          ocdrServiceAdd
        });
      }
    } else {
      const fields = getFormData(formFields);
      if (Object.entries(fields).length) {
        onSaveAndExit(fields);
      }
    }
  };
  const prevStep = e => {
    e.preventDefault();
    setFormErrors({});
    setIsLoading(true);
    setIsFormSubmit(false);
    setDataLoaded(false);
    if (
      !orderData.productSelectionOCDR.includes(
        fieldMicrosoftCloudAndAdvisoryServices
      )
    ) {
      updateStep(step - 2);
      history.push({
        pathname: `/${locale}/${categoryOCDR}/${ocdrForm}`,
        search: `?orderId=${orderData.id}&step=${step - 2}&isEditing=true`
      });
    } else {
      updateStep(step - 1);
      history.push({
        pathname: `/${locale}/${categoryOCDR}/${ocdrForm}`,
        search: `?orderId=${orderData.id}&step=${step - 1}&isEditing=true`
      });
    }
  };
  const nextStep = async (e, isFrenchVersionDownload) => {
    e.preventDefault();
    let isQuoteApproveRequired;

    const errors = getErrors(formStepFields, { ...formErrors });
    setFormErrors(errors);
    const bundleName = get(formFields, 'orderInclude.value', '');
    const contractTerm = get(formFields, 'contractTerm.value', '');

    isQuoteApproveRequired = getIsQuoteApproveRequired(
      products,
      matchProductsData,
      hasProductDirectRouting,
      bundleName,
      contractTerm
    );
    if (hasProductMicrosoftCloud && !isQuoteApproveRequired) {
      isQuoteApproveRequired = getIsQuoteApproveRequiredForMCProduct(
        ocdrProductAdd['selections'],
        productPriceofMC,
        get(formFields, 'contractTerm.value', '')
      );
    }

    if (steps.length === step && Object.keys(orderData).length > 0) {
      const quoteApproveRequired = get(orderData, 'isQuoteApproveRequired');
      if (!quoteApproveRequired) {
        const pdfLang = isFrenchVersionDownload ? 'fr-CA' : 'en-US';
        // Await this before continuing to the final-step save below — that save ends in
        // window.location.reload(), which aborts every in-flight request (browser-level);
        // without awaiting, the reload was firing before the PDF polling ever finished.
        setDownloadingLang(pdfLang);
        await quotePdf.openPdf({
          orderId: orderData.id,
          route: `${apiHost}/orders/${orderData.id}/quote-pdf?lang=${pdfLang}`
        });
      }
    }
    if (Object.entries(errors).length === 0) {
      if (step === 1) {
        if (!hasProductDirectRouting && !hasProductOperatorConnect) {
          resetHardwarAndServices();
        }
        const fields = getFormData(formFields, products);
         const ocdrSummaryPayload =  getOcdrSummaryPayload(
          {
            ...fields,
            isQuoteApproveRequired,
            hardwareData,
            ocdrProductAdd,
            ocdrServiceAdd
          },
          hasProductDirectRouting,
          hasProductOperatorConnect,
          hasProductMicrosoftCloud
        );
        onFormSubmit({
          ...fields,
          isQuoteApproveRequired,
          hardwareData,
          ocdrProductAdd,
          ocdrServiceAdd,
          ocdrSummaryPayload
        });
      } else {
        const fields = getFormData(formFields);
        onFormSubmit(fields, true, step === steps.length);
      }
    } else {
      const firstError = errors[Object.keys(errors)[0]];
      const { ref } = firstError;
      if (ref && ref.current) ref.current.focus();
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [step]);
  const resetFormFields = (fields, name) => {
    const { resetFields, customResetFields } = fields[name];
    const updatedFields = Object.keys(fields).reduce((acc, fieldKey) => {
      const currentFormField = findField(formStepFields, fieldKey);
      // If field type is array, then it'll be ignored with the below logic
      if (isArray(fields[fieldKey])) {
        return { ...acc, [fieldKey]: fields[fieldKey] };
      }
      const isVisible = isRelatedFieldExisted(
        get(currentFormField, 'fields', {}),
        fields,
        orderData,
        true
      );
      if (!isVisible)
        return { ...acc, [fieldKey]: { ...fields[fieldKey], value: '' } };
      return { ...acc, [fieldKey]: { ...fields[fieldKey] } };
    }, {});
    if (resetFields) {
      resetFields.forEach(field => {
        const fieldName = _.get(field, 'fields.name', '');
        if (fieldName && _.has(updatedFields[fieldName], 'value'))
          updatedFields[fieldName].value = '';
      });
    }
    if (customResetFields) {
      customResetFields.forEach(field => {
        const fieldName = _.get(field, 'fields.key', '');
        if (fieldName && _.has(updatedFields[fieldName], 'value'))
          updatedFields[fieldName].value = '';
        else delete updatedFields[fieldName];
      });
    }
    return updatedFields;
  };

  const resetSelectedFields = (fields, isCustom = false) => {
    if (fields.length > 0) {
      const updatedOrderData = { ...orderData };
      fields.forEach(field => {
        const keyPath = isCustom ? 'fields.key' : 'fields.name';
        const fieldName = _.get(field, keyPath, '');
        if (_.has(orderData, fieldName)) {
          updatedOrderData[fieldName] = '';
        }
      });
      // setIsFieldReset(true);
      setOrderData(updatedOrderData);
    }
  };

  const handleFormField = (
    { name, value, checked, files },
    ref,
    isFieldModified
  ) => {
    const fields = { ...formFields };
    if (isFieldModified && !isFormTouched) {
      setIsFormTouched(true);
    }
    fields[name] = { ...fields[name], value, checked, isVisible: true };

    if (name === fieldProductSelectionOCDR) {
      if (!value.includes(fieldDirectRouting)) {
        setProducts(prevStep => ({
          ...prevStep,
          'Direct Routing': matchProductsData['Direct Routing']
        }));
      }
      if (!value.includes(fieldOperatorConnect)) {
        setProducts(prevStep => ({
          ...prevStep,
          'Operator Connect': matchProductsData['Operator Connect']
        }));
      }
    }

    if(name === 'contractTerm'){
      setocdrProductAdd({});
      setMicrosoftlicensingSelections([]);
    }

    const shouldApplyPricing =
      name === 'contractTerm' ||
      name === 'orderInclude' ||
      (name === fieldProductSelectionOCDR &&
        (value.includes(fieldDirectRouting) ||
          value.includes(fieldOperatorConnect)));

    if (shouldApplyPricing) {
      const bundleName =
        name === 'orderInclude'
          ? value
          : get(formFields, 'orderInclude.value', '');

      const contractTerm =
        name === 'contractTerm'
          ? value
          : get(formFields, 'contractTerm.value', '');

      const isDirectRoutingSelected =
        name === fieldProductSelectionOCDR
          ? value.includes(fieldDirectRouting)
          : hasProductDirectRouting;

      setProducts(prevProducts =>
        applyBundlePricing(
          prevProducts,
          matchProductsData,
          bundleName,
          contractTerm,
          isDirectRoutingSelected
        )
      );
    }

    // Form sections visibility can be related to fields and values
    updateSections(getHiddenSections(fields));
    if (files && files.length) {
      const [file] = files;
      const checkFileExists = (filesToCheck, fileKey) =>
        filesToCheck.find(fileDetails => fileDetails[fileKey]);
      const updateFile = (fileList, fileKey, updatedFile) => {
        const updatedFileList = fileList.map(fileDetails => {
          if (fileDetails[fileKey]) {
            // eslint-disable-next-line no-param-reassign
            fileDetails[name] = updatedFile;
          }
          return fileDetails;
        });
        return updatedFileList;
      };
      if (
        fields.files &&
        fields.files.length &&
        !checkFileExists(fields.files, name)
      ) {
        fields.files.push({ [name]: file });
      } else if (
        fields.files &&
        fields.files.length &&
        checkFileExists(fields.files, name)
      ) {
        const updatedFileList = updateFile(fields.files, name, file);
        fields.files = updatedFileList;
      } else {
        fields.files = [{ [name]: file }];
      }
      fields[name].value = file.name;
    }
    setFormFields(resetFormFields(fields, name));

    // Reset Selected Fields Logic
    if (_.has(fields, `${name}.resetFields`)) {
      resetSelectedFields(_.get(fields, `${name}.resetFields`, []));
    } else if (_.has(fields, `${name}.customResetFields`)) {
      resetSelectedFields(_.get(fields, `${name}.customResetFields`, []), true);
    }
  };
  const renderFormFields = (data, expandProps) =>
    data &&
    data.length > 0 &&
    data.map(({ sys, fields }, indexRoot) => {
      const {
        contentType: {
          sys: { id }
        },
        id: sysId
      } = sys;
      //   const disableOptions = (options, targets, value) => {
      //     const updatedOptions = [...options];
      //     targets.forEach(target => {
      //       updatedOptions.forEach(option => {
      //         if (option.fields.value === target) {
      //           // eslint-disable-next-line no-param-reassign
      //           option.fields.disabledOption = value;
      //         }
      //       });
      //     });
      //     return updatedOptions;
      //   };
      const { name: fieldName, title, expiredDate } = fields;
      let selectOptions;
      const error = formErrors[fieldName];
      const key = `FormField${fieldName}${indexRoot}${sysId}`;
      let result;
      let fieldNote;
      if (expiredDate && new Date(expiredDate) < new Date()) return null;
      if (!isRelatedFieldExisted(fields, formFields, orderData, isFormTouched))
        return null;
      const fieldValue = getFieldValue(fieldName, formFields);
      hasProductDirectRouting =
      formFields &&
      formFields.productSelectionOCDR &&
      formFields.productSelectionOCDR.value &&
      formFields.productSelectionOCDR.value.includes(fieldDirectRouting);
      
      hasProductOperatorConnect =
      formFields &&
      formFields.productSelectionOCDR &&
      formFields.productSelectionOCDR.value &&
      formFields.productSelectionOCDR.value.includes(fieldOperatorConnect);

      hasProductMicrosoftCloud =
        formFields &&
        formFields.productSelectionOCDR &&
        formFields.productSelectionOCDR.value &&
        formFields.productSelectionOCDR.value.includes(fieldMicrosoftCloudAndAdvisoryServices);

      // Prequalification Section
      const returnPrequalificationSectionValue = PrequalificationSection(
        formFields,
        fieldName,
        isCreateOrderButtonVisible
      );

      // MicrosoftCloudAdvisoryServicesSection
      const returnMicrosoftCloudAdvisoryServicesSectionValue = MicrosoftCloudAdvisoryServicesSection(
        formFields,
        fieldName
      );

      // ProductDetailsSection
      ProductDetailsSection(formFields, fieldName, fields);

      if (
        returnPrequalificationSectionValue ||
        returnMicrosoftCloudAdvisoryServicesSectionValue
      ) {
        return null;
      }

      if (id === formFieldsGroup) {
        const groupIsVisible = fields.fields.find(item => {
          const { fields: itemFields } = item;
          if (!formFields[itemFields.name]) return null;
          const { value, isVisible } = formFields[itemFields.name];
          return (
            (value && isVisible) ||
            isRelatedFieldExisted(
              itemFields,
              formFields,
              orderData,
              isFormTouched
            )
          );
        });
        if (typeof groupIsVisible !== 'undefined') {
          result = (
            <GroupWrapper key={key}>
              {title && <GroupTitle>{title}</GroupTitle>}
              {renderFormFields(fields.fields)}
            </GroupWrapper>
          );
        }
      } else if (id === formSectionTitle) {
        const { title: sectionTitle } = fields;
        return <Typography heading="h3" variant={{ size: 'h3' }} block>{sectionTitle}</Typography>;
      } else if (id === formSection) {
        // below if condition is made not to be executed due to some rendering issues(for Annas)
        if (step === 3 && formStepName === 'Order Summaryy') {
          result = orderData && steps && (
            <OrderSummary
              stepData={steps}
              orderData={orderData}
              isFormSubmit={setIsFormSubmit}
              isQuestionVisible={isFormSubmit}
            />
          );
        } else {
          const { note } = fields;
          const renderNote = note && note.content && (
            <Note
              data={note}
              type="richText"
              isShowNoteBackground={fields.isShowNoteBackground}
              isWarningMessage={fields.isWarningMessage}
              isColorRed={fields.isColorRed}
              isItalicNote={fields.isItalicNote}
            />
          );
          const { name } = role || {};
          result = title && sectionIsVisible(fieldName) && (
            <ExpandCollapse.Panel
              {...expandProps}
              key={key}
              panelId={fieldName}
              control={
                <Typography variant={{ size: 'h2' }}>
                  {formStepBackendKey === stepKeyMain && locale !== localeFrench
                    ? `${roleLabels[name]} ${title}`
                    : `${title}`}
                </Typography>
              }
            >
              <>
                {renderNote && renderNote}
                {renderFormFields(fields.formFields, expandProps)}
                {step === 3 && (
                  <OrderSummary
                    stepData={steps}
                    orderData={orderData}
                    isFormSubmit={setIsFormSubmit}
                    isQuestionVisible={isFormSubmit}
                  />
                )}
                {/* {formSummaryGroup
          ? renderFormSummary(formSummaryGroup)
          : renderFormFields(fields.formFields)} */}
              </>
            </ExpandCollapse.Panel>
          );
        }
      } else if (id === userDetailsKey) {
        const disabled = false;
        const isSameAsCheckboxChecked = false;
        result = (
          <UserDetailsForm
            key={key}
            data={fields}
            setFormFields={setFormFields}
            orderData={orderData}
            formErrors={formErrors}
            formFields={formFields}
            isEditing={isEditing}
            isFormTouched={isFormTouched}
            setIsFormTouched={setIsFormTouched}
            disabled={disabled}
            isSameAsCheckboxChecked={isSameAsCheckboxChecked}
          />
        );
      } else if (id === repeatedFormKey) {
        result = (
          <RepeatedForm
            key={key}
            data={fields}
            setFormFields={setFormFields}
            orderData={orderData}
            formErrors={formErrors}
            formFields={formFields}
            isEditing={isEditing}
            isFormTouched={isFormTouched}
            setIsFormTouched={setIsFormTouched}
          />
        );
      } else if (id === 'note') {
        const dataObj = {
          type: 'TextNote',
          note: fields.content,
          isShowNoteBackground: true
        };
        result = <FormField data={dataObj} />;
      } else if (fields.type === 'ServiceTable') {
        const { categoryName, subCategoryName } = fields.customConfigurations;
        return (
          <Services
            products={get(
              products,
              `${[categoryName]}.${[subCategoryName]}`,
              []
            )}
            label={subCategoryName}
            onProductsChange={productsUpdated => {
              setProducts(prev => ({
                ...prev,
                [categoryName]: {
                  ...prev[categoryName],
                  [subCategoryName]: [...productsUpdated]
                }
              }));
            }}
            error={error}
            // bundleName={get(formFields, 'orderInclude.value', '')}
            // contractTerm={get(formFields, 'contractTerm.value', '')}
            // hasProductDirectRouting={hasProductDirectRouting}
            // operatorConnectData={operatorConnectData}
            // directRoutingData={directRoutingData}
            // subCategoryName={subCategoryName}
          />
        );
      } else if (fields.type === 'HardwarePopup') {
        return (
          <OcdrHardware
            defaultValues={get(orderData, 'hardwareData', {})}
            orderData={orderData}
            onChange={onChangeHardwareData}
            productsPriceData={matchProductsData}
            productName={get(formFields, 'productSelectionOCDR.value', [])}
          />
        );
      } else if (fields.type === 'CustomerServicePopup') {
        return (
          <OcrdService
            defaultValues={get(orderData, 'ocdrServiceAdd', {})}
            orderData={orderData}
            onChange={onChangeOcdrService}
          />
        );
      } else if (fields.type === 'MCPopup') {
        return (
          <OcdrAddProduct
            defaultValues={get(orderData, 'ocdrProductAdd', {})}
            orderData={orderData}
            onChange={onChangeOcdrProduct}
            productPriceofMC={productPriceofMC}
            bundleName={get(formFields, 'orderInclude.value', '')}
            contractTerm={get(formFields, 'contractTerm.value', '')}
            microsoftlicensingSelections={microsoftlicensingSelections}
            setMicrosoftlicensingSelections={setMicrosoftlicensingSelections}
            errorMC={errorMC}
          />
        );
      } else {
        const fieldButtonProps = fields.type === 'Button' ? { modalForms } : {};
        let ref;
        let isDisabled;
        if (formFields[fieldName]) {
          ({ ref, isDisabled } = formFields[fieldName]);
        }
        const newFields = [];
        const update = false;
        // const channelName = profile.channel ? profile.channel.name : null;
        const fieldData = {
          ...fields,
          options: selectOptions || update ? newFields : fields.options,
          ...fieldButtonProps,
          note: fieldNote || fields.note,
          ref,
          formFields,
          name: fieldName,
          value: fieldValue,
          disabled: isDisabled,
          readonly: isDisabled,
          sysId,
          onChange: (e, refV) => handleFormField(e.target, refV, true),
          onBlur: () => {}
        };
        if (!isFormTouched && fields.type === 'Checkbox') {
          fieldData.checked = fieldValue;
        }
        result = (
          <FormField key={key} data={fieldData} error={error && error.text} />
        );
      }
      return result;
    });
  return (
    <div ref={formStepRef}>
      {!hideProgressBar && (
        <ProgressBar
          name={formStepName}
          steps={steps}
          currentStep={step}
          locale={locale}
          formName={formName}
        />
      )}
      <div></div>
      {isLoading ? (
        <ValidateLoader
          message="Please wait request is In progress...."
          isFormStep
        />
      ) : (
        <form
          name={formStepName}
          onSubmit={e => nextStep(e)}
          ref={ref => setFormRef && setFormRef(ref)}
        >
          {sections.length && formStepName !== 'OCDR Landing Page' ? (
            <Box
              style={{
                border: '1px solid #e3e3e3',
                boxShadow: '1px 1px 9px 4px #e3e3e3',
                padding: '2rem',
                marginBottom: '1rem',
                marginLeft: '4rem',
                marginRight: '4rem'
              }}
            >
              <div className="expand">
                <ExpandCollapse key={open.join('|') || 'empty'} tag="h2" topDivider={false} initialOpen={[...open]}>
                  {expandProps => renderFormFields(formStepFields, expandProps)}
                </ExpandCollapse>
              </div>
            </Box>
          ) : (
            <div style={{ width: '1000px' }}>
              {formStepFields ? (
                <Box
                  style={{
                    border: '1px solid #e3e3e3',
                    boxShadow: '1px 1px 9px 4px #e3e3e3',
                    padding: '2rem',
                    marginBottom: '1rem',
                    marginLeft: '4rem',
                    marginRight: '4rem'
                  }}
                >
                  <div className="expand">
                    <ExpandCollapse
                      key={open.join('|') || 'empty'}
                      tag="h2"
                      topDivider={false}
                      initialOpen={[...open]}
                    >
                      {expandProps => renderFormFields(formStepFields, expandProps)}
                    </ExpandCollapse>
                  </div>
                </Box>
              ) : (
                <>
                  <div style={{ marginBottom: '1em' }}>
                    <Typography heading="h3" variant={{ size: 'h3' }} block>{summaryLabel}</Typography>
                  </div>
                  {/* {getSummary()} */}
                </>
              )}
            </div>
          )}
        </form>
      )}
      {formName === ocdrForm && (
        <OcdrStatusBar
          step={step}
          isLastStep={steps.length === step}
          isFormTouched={isFormTouched}
          isFormSubmit={isFormSubmit}
          onBackClick={prevStep}
          onProceedClick={nextStep}
          onSaveAndExit={saveAndExit}
          totals={getServicesTotals(
            products,
            get(formFields, 'contractTerm.value', ''),
            get(formFields, 'productSelectionOCDR.value', []),
            orderData,
            step
          )}
          harwareAndServiceMonthlyPrice={getHarwareAndServiceTotal('monthly')}
          harwareAndServiceOneTimePrice={getHarwareAndServiceTotal('oneTime')}
          microsoftCloudMonthlyPrice={getMicrosoftCloudTotal('monthly')}
          microsoftCloudOneTimePrice={getMicrosoftCloudTotal('oneTime')}
          isQuoteApproveRequired={get(orderData, 'isQuoteApproveRequired', false)}
          quotePdfStatus={quotePdf.status}
          downloadingLang={downloadingLang}
        />
      )}
    </div>
  );
};
FormStepOCDR.propTypes = {
  stepData: PropTypes.shape({
    fields: PropTypes.shape({
      name: PropTypes.string,
      image: PropTypes.string,
      formStepFields: PropTypes.arrayOf(PropTypes.shape({})),
      showTotal: PropTypes.bool,
      modalForms: PropTypes.arrayOf(PropTypes.shape({})),
      backendKey: PropTypes.string
    })
  }),
  steps: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  step: PropTypes.number.isRequired,
  updateStep: PropTypes.func,
  setFormRef: PropTypes.func,
  onFormSubmit: PropTypes.func,
  onSaveAndExit: PropTypes.func,
  setOrderData: PropTypes.func,
  orderData: PropTypes.shape({
    id: PropTypes.number,
    products: PropTypes.shape({})
  }),
  hideProgressBar: PropTypes.bool,
  isEditing: PropTypes.string.isRequired,
  formName: PropTypes.string.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func
  }).isRequired,
  isCreateOrderButtonVisible: PropTypes.bool
};
export default FormStepOCDR;
